import { useEffect } from 'react';
import wasmUrl from 'zxing-wasm/reader/zxing_reader.wasm?url';
import { useCatalog } from '@/lib/useCatalog';

/**
 * Deja la app lista para funcionar sin red, nada más entrar.
 *
 * Una app offline-first que necesita conexión la primera vez que abres una
 * pantalla no es offline-first: quien instalaba la PWA en casa y abría
 * «Añadir» en el súper sin cobertura se encontraba sin catálogo, y el escáner
 * sin `.wasm` no decodificaba nada.
 *
 * Las dos descargas son de UNA vez y van en segundo plano, detrás del primer
 * pintado: el catálogo a IndexedDB (lo comparte `useCatalog`, así que no se
 * baja dos veces) y el `.wasm` a la caché del service worker.
 */
export function Prefetch() {
  useCatalog();

  useEffect(() => {
    const worker = navigator.serviceWorker;
    if (!worker) return;

    const warm = () => {
      void (async () => {
        // Ya guardado: no se vuelve a pedir en cada arranque.
        if (await caches.match(wasmUrl)) return;
        await fetch(wasmUrl);
      })().catch(() => undefined /* Se bajará al escanear, como antes. */);
    };

    // Tiene que CONTROLAR la página, no solo estar activo: una petición que
    // sale antes de que reclame el control no pasa por él y no se guarda en
    // ninguna caché. En `dev` no hay service worker y no se baja nada.
    if (worker.controller) warm();
    else worker.addEventListener('controllerchange', warm, { once: true });

    return () => worker.removeEventListener('controllerchange', warm);
  }, []);

  return null;
}
